import React from "react";
import Text from "@/components/ui/text";
import { getFieldDisplayTypeIcon, getFieldDisplayTypeLabel } from "../hooks";
import { APIFieldItem } from "@/pages/settings/types";
import { Resolve } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import { useTranslation } from "react-i18next";

interface PresetFieldProps {
  scoField: APIFieldItem;
  onEdit?: (field: APIFieldItem) => void;
}

export const PresetField: React.FC<PresetFieldProps> = ({
  scoField,
  onEdit
}) => {
  const { t } = useTranslation();
  const handleClick = () => {
    onEdit?.(scoField);
  };

  return (
    <div
      className="flex flex-col gap-1 p-3 cursor-pointer border border-transparent hover:bg-surface-hover-soft hover:border hover:border-border-border1 rounded-[6px]"
      onClick={handleClick}
    >
      <div className="flex justify-between items-center">
        <Text variant="body">{scoField.label}</Text>
        <div className="flex flex-row gap-1 rounded-[6px] bg-badges-filled border border-badges-selected p-1 items-center">
          <IconContainer>
            <Resolve />
          </IconContainer>
          <Text variant="body">{"In use"}</Text>
        </div>
      </div>
      <Text variant="bodySecondary">{scoField.helpText}</Text>
      <div className="flex flex-row gap-1 items-center">
        {getFieldDisplayTypeIcon(scoField.displayType, "secondary")}
        <Text variant="smBodySecondary" className="truncate">
          {getFieldDisplayTypeLabel(scoField.displayType, t)}
        </Text>
      </div>
    </div>
  );
};
